import fetch from 'isomorphic-fetch';
import _difference from 'lodash/difference';
import * as ActionTypes from './types/EventActionTypes';
import ApiService from '../util/api';
import { receiveWeddingAccount } from './WeddingActions';
import * as NotificationsActions from './NotificationActions';

// TODO: MOVE THIS AND USE FOR ALL REQUESTS!!!!
function handleErrors(response) {
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
}

export function requestEvent() {
  return {
    type: ActionTypes.REQUEST_EVENT
  };
}

export function receiveEvent(json) {
  return {
    type: ActionTypes.RECEIVE_EVENT,
    payload: {
      eventView: json
    }
  };
}

export function requestEvents() {
  return {
    type: ActionTypes.REQUEST_EVENTS
  };
}

export function requestEventsRsvpPage() {
  return {
    type: ActionTypes.REQUEST_EVENTS_RSVP_PAGE
  };
}

export function receiveEvents(json) {
  return {
    type: ActionTypes.RECEIVE_EVENTS,
    payload: {
      events: json
    }
  };
}

export function receiveEventsByDate(json) {
  return {
    type: ActionTypes.RECEIVE_EVENTS_BY_DATE,
    payload: {
      groupedEventsByDate: json
    }
  };
}

export function requestSuggestedAttireOptions() {
  return {
    type: ActionTypes.SUGGESTED_ATTIRE_OPTIONS_REQUESTED
  };
}

export function receiveSuggestedAttireOptions(data) {
  return {
    type: ActionTypes.SUGGESTED_ATTIRE_OPTIONS_RECEIVED,
    payload: data
  };
}

export function receiveEventsRsvpPage(json) {
  return {
    type: ActionTypes.RECEIVE_EVENTS_RSVP_PAGE,
    payload: {
      events: json.events,
      hidden: json.hidden,
      id: json.id
    }
  };
}

export function requestSuggestions() {
  return {
    type: ActionTypes.SUGGESTIONS_REQUESTED
  };
}

export function receiveSuggestions(data) {
  return {
    type: ActionTypes.SUGGESTIONS_RECEIVED,
    payload: data
  };
}

export function selectEvent(selectedId) {
  return {
    type: ActionTypes.SELECT_EVENT,
    payload: {
      selectedId
    }
  };
}

function requestMigrationEvents() {
  return {
    type: ActionTypes.REQUEST_MIGRATION_EVENTS,
  };
}

function receiveMigrationEvents(json) {
  return {
    type: ActionTypes.RECEIVE_MIGRATION_EVENTS,
    payload: {
      events: json
    }
  };
}

function beginMigrating() {
  return {
    type: ActionTypes.BEGIN_MIGRATING
  };
}

function finishMigrating() {
  return {
    type: ActionTypes.FINISH_MIGRATING
  };
}

export function fetchEvents() {
  return (dispatch) => {
    dispatch(requestEvents());
    return fetch('/web-api/v2/cms/events',
      {
        credentials: 'same-origin',
      })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(receiveEvents(json)));
  };
}

export function fetchEventsByDate() {
  return (dispatch) => {
    dispatch(requestEvents());
    return fetch('/web-api/v2/cms/events-by-date',
      {
        credentials: 'same-origin',
      })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(receiveEventsByDate(json)));
  };
}

const handleEventErrors = (error, dispatch) => {
  if (error.status) {
    const { domain } = error.category;
    let errorMessage;
    switch (domain) {
      case 'event':
        errorMessage = 'Cannot Delete Event: already received RSVPs.';
        break;
      case 'meal-option':
        errorMessage = 'Cannot Delete Meal Option: already selected by guests.';
        break;
      case 'rsvp-question':
        errorMessage = 'Cannot Delete RSVP Question: already answered by guests.';
        break;
      case 'seating-chart':
        errorMessage = 'Cannot Delete Event: please remove seating chart first.';
        break;
      default:
        errorMessage = 'There was an with your request. Please try again.';
    }
    dispatch(NotificationsActions.error({ message: errorMessage }));
    throw new Error('error');
  }
};

export function createEvent(eventRequest) {
  return (dispatch) => { // eslint-disable-line
    return ApiService.post('/web-api/v2/cms/events', eventRequest)
      .then(e => handleEventErrors(e, dispatch))
      .then(() => dispatch(fetchEventsByDate()))
      .then(() => dispatch(NotificationsActions.confirmation({ message: 'Event Added' })));
  };
}

export function updateEvent(eventRequest) {
  return (dispatch) => { // eslint-disable-line
    return ApiService.post('/web-api/v2/cms/events/update', eventRequest)
      .then(e => handleEventErrors(e, dispatch))
      .then(() => dispatch(fetchEventsByDate()))
      .then(() => dispatch(NotificationsActions.confirmation({ message: 'Event Updated' })));
  };
}

export function deleteEvent(id) {
  return (dispatch) => { // eslint-disable-line
    return ApiService.post('/web-api/v2/cms/events/delete', { id })
      .then(e => handleEventErrors(e, dispatch))
      .then(() => dispatch(fetchEventsByDate()))
      .then(() => dispatch(NotificationsActions.confirmation({ message: 'Event Deleted' })));
  };
}

export function fetchSuggestedAttireOptions() {
  return (dispatch) => {
    dispatch(requestSuggestedAttireOptions());
    return fetch('/web-api/v2/cms/page/event/attire/suggestions',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveSuggestedAttireOptions(json)));
  };
}

// used on guest list to fetch events and rsvp status in one request
export function fetchEventsRsvpPage() {
  return (dispatch) => {
    dispatch(requestEventsRsvpPage());
    return fetch('/web-api/v2/cms/page/rsvp',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveEventsRsvpPage(json)));
  };
}

// might want a new endpoint for this not linked to the rsvp page - discuss with platform
export function fetchSuggestedRsvpQuestions() {
  return (dispatch) => {
    dispatch(requestSuggestions());
    return fetch('/web-api/v1/cms/page/rsvp/suggestions',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveSuggestions(json)));
  };
}

export function getMigrationEvents() {
  return (dispatch) => {
    dispatch(requestMigrationEvents());
    return fetch('/web-api/v2/cms/migrate/events',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveMigrationEvents(json)));
  };
}

export function migrateWeddingAccount(eventId) {
  return (dispatch, getState) => {
    dispatch(beginMigrating());
    const eventIds = getState().events.events.orderedIds;
    const migrationEventIds = getState().events.migration.orderedIds;
    const createdEventId = _difference(eventIds, migrationEventIds)[0];
    const finalEventId = eventId || createdEventId;
    return fetch(`/web-api/v2/cms/migrate/events/id/${finalEventId}`,
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
      })
      .then(response => response.json())
      .then(json => dispatch(receiveWeddingAccount(json)))
      .then(() => dispatch(finishMigrating()));
  };
}

export function createEventAndMigrate(eventRequest) {
  return (dispatch) => { // eslint-disable-line
    return fetch('/web-api/v2/cms/events',
      {
        credentials: 'same-origin',
        headers: {
          'Content-type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(eventRequest)
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((json) => { dispatch(migrateWeddingAccount(json.id)); });
  };
}



// WEBPACK FOOTER //
// ./src/actions/EventActions.js